import { TestimonialsCard } from '../TestimonialsCard'
import {TestimonialContainer,TestimonialContent, TestimonialSection} from './styles'

export function Testimonials(){
    return(
        <TestimonialSection id="testimonials">
            <TestimonialContainer>
                <h2>Depoimentos</h2>
                <p>Um pouco do que os clientes dizem sobre mim!</p>
                <TestimonialContent>
                    <TestimonialsCard/>
                </TestimonialContent>
            </TestimonialContainer>
        </TestimonialSection>
    )
}